import React from 'react';
import { stepShowHide } from '../../../utilities/form/formUtils';
import Text from '../../Global/Text';
import Icon from '../../Global/Icon';
import { getCoverageTitle } from '../../../utilities/coverage/titleUtils';

export const CombinedSummaryDetails = (props) => {
    const { title, activationDate, showHide, userData, hidden, packages} = props;
    const { coverageList } = userData;
    const showHideresult = stepShowHide(hidden, showHide, userData);

  return (
    <>
        {!showHideresult ? 
            <div className='summaryDetails'>
                <Text value={title}/>
                <div className='summaryDetails_activationDate'>
                    <Icon {...{ icon: 'checkmark', fill: 'black' }} />
                    <Text value="Basisdækning"/>
                </div>
                {packages && packages.length > 0 &&
                    packages.map((item) => {
                        if(userData[item.name]){
                            return(
                            <div className='summaryDetails_activationDate' key= {item.name}>
                                <Icon {...{ icon: 'checkmark', fill: 'black' }} />
                                <span>
                                    {!item.displayName ? getCoverageTitle({}, coverageList, {}, "", item.package, true) : item.displayName }
                                </span>
                            </div>
                            )
                        }
                    })
                }
                <div className='summaryDetails_activationDate'>
                    <Icon {...{ icon: 'checkmark', fill: 'black' }} />
                    <Text value={activationDate}/>
                </div>
            </div>
            : <div/>
        }
    </>
  );
}